<template>
  <div class="p-0">
    <div class="p-0" v-if="!loading">
      <div class="p-0 m-5" v-if="tasks && tasks.data && tasks.data.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <td>Tytuł</td>
              <td>Opis</td>
              <td>Pracownik</td>
              <td>Kategoria</td>
              <td>Data utworzenia</td>
              <td>Priorytet</td>
              <td class="edit-icon">
                <img
                  @click="handleOpenAddTaskModal"
                  src="../../icons/dod/edit_task.svg"
                  alt=""
                />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="task of tasks.data" :key="task.id">
              <td>{{ task.title }}</td>
              <td>{{ task.description }}</td>
              <td>{{ task.admins.map((a) => a.admin).join(", ") }}</td>
              <td>{{ task.category.name }}</td>
              <td>{{ formatDate(task.createdAt) }}</td>
              <td>{{ task.priority.name }}</td>
              <td>
                <gradient-button
                  @handleClick="handleTaskCardClick(task)"
                  title="Zobacz"
                  :customStyles="'width: 134px; height: 19px'"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="p-0 m-5">
        <dod-custom-add-button
          @click="handleOpenAddTaskModal"
          :title="'Dodaj zadanie'"
        />
        <dod-empty-list style="margin-top: 1rem" />
      </div>

      <custom-modal
        id="dodAddOrEditTask"
        :title="''"
        :withMenuDots="selectedTask && selectedTask.id"
      >
        <template #title>
          <div
            v-if="
              selectedTask &&
              selectedTask.id &&
              selectedTask.status !== 'FINISHED'
            "
            @click="finishTask"
            class="finish-task-button"
          >
            Oznacz jako zrobione
          </div>
          <div
            v-else-if="selectedTask && selectedTask.id"
            class="task-finished-button"
          >
            Zadanie zakończone
          </div>
        </template>
        <template #content>
          <add-or-edit-task
            :task="selectedTask"
            @updateTask="(e) => updateTask(e)"
            @newTask="(e) => newTask(e)"
            @messageSend="(e) => handleSendMessage(e)"
            :employeeUser="
              !selectedTask || !selectedTask.id ? selectedEmployee : null
            "
          />
        </template>

        <template #menuContent>
          <div class="dots-content" @click="removeTask">
            <img src="../../icons/dod/trash.svg" alt="" />
            <span>Usuń</span>
          </div>
        </template>
      </custom-modal>
      <button
        style="visibility: hidden"
        id="dodAddOrEditTask-open"
        type="button"
        data-toggle="modal"
        data-target="#dodAddOrEditTask"
      />
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import shared from "../../shared";
import CustomModal from "../CustomModal.vue";
import Loader from "../Loader.vue";
import AddOrEditTask from "./AddOrEditTask.vue";
import DodCustomAddButton from "./DodCustomAddButton.vue";
import DodEmptyList from "./DodEmptyList.vue";
import GradientButton from "./GradientButton.vue";
export default {
  components: {
    GradientButton,
    DodEmptyList,
    DodCustomAddButton,
    CustomModal,
    AddOrEditTask,
    Loader,
  },
  props: ["employeeId"],
  name: "EmployeeTasks",
  data() {
    return {
      selectedTask: {},
      loading: true,
    };
  },
  async mounted() {
    await this.$store.dispatch("fetchDodEmployeeTasks", this.employeeId);
    this.loading = false;
  },

  methods: {
    formatDate(date) {
      return shared.dateToDayMonthYearFormat(date);
    },
    handleTaskCardClick(task) {
      this.selectedTask = task;
      const button = document.getElementById("dodAddOrEditTask-open");
      if (button) {
        button.click();
      }
    },
    handleOpenAddTaskModal() {
      this.selectedTask = {};
      const button = document.getElementById("dodAddOrEditTask-open");
      if (button) {
        button.click();
      }
    },

    async finishTask() {
      if (
        confirm(
          ` Czy na pewno chcesz zakończyć zadanie: ${this.selectedTask.title}?`
        )
      ) {
        this.updateTask({ status: "FINISHED" });
      }
    },

    async removeTaskConfirmed() {
      await this.$store.dispatch("removeDodTask", this.selectedTask.id);
      this.selectedTask = null;
      this.$notify({
        group: "success",
        text: "Zadanie zostało pomyślnie usunięte",
      });
      document.getElementById("dodAddOrEditTask-close").click();
      await this.$store.dispatch("fetchDodEmployeeTasks", this.employeeId);
    },

    async newTask(data) {
      try {
        await this.$store.dispatch("addDodTask", {
          title: data.title || "",
          categoryId: data.categoryId || "",
          priorityId: data.priorityId || "",
          dueDate: data.dueDate || "",
          status: data.status || "ACTIVE",
          employeeId: data.employeeId || "",
          customerId: data.customerId || "",
          description: data.description || "",
          admins: data.admins || [],
        });
        this.selectedTask = null;
        this.$notify({
          group: "success",
          text: "Zadanie zostało dodane",
        });
        document.getElementById("dodAddOrEditTask-close").click();
        await this.$store.dispatch("fetchDodEmployeeTasks", this.employeeId);
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wszystkie pola muszą być uzupełnione",
          });
        } else {
          this.$notify({
            group: "error",
            text: error.data.message,
          });
        }
      }
    },

    async handleSendMessage(message) {
      try {
        await this.$store.dispatch("addMessage", {
          text: message.text || "",
          admin: this.admin.phone,
          type: "EMPLOYEE",
          employeeId: message.employeeId || "",
          customerId: message.customerId || "",
          taskId: this.selectedTask.id,
          isAction: false,
        });
        await this.$store.dispatch("fetchDodEmployeeTasks", this.employeeId);
        this.selectedTask = (this.tasks && this.tasks.data || []).find(
          (elem) => elem.id === this.selectedTask.id
        );
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wiadomość nie może być pusta",
          });
        } else {
          console.log(error);
        }
      }
    },

    async removeTask() {
      if (
        confirm(
          ` Czy na pewno chcesz usunąć zadanie: ${this.selectedTask.title}?`
        )
      ) {
        this.removeTaskConfirmed();
      }
    },

    async updateTask(data) {
      try {
        await this.$store.dispatch("updateDodTask", {
          taskId: this.selectedTask.id,
          title: data.title || this.selectedTask.title,
          categoryId: data.categoryId || this.selectedTask.category.id,
          priorityId: data.priorityId || this.selectedTask.priority.id,
          dueDate: data.dueDate || this.selectedTask.dueDate,
          status: data.status || this.selectedTask.status,
          employeeId: data.employeeId || "",
          customerId: data.customerId || "",
          description: data.description || this.selectedTask.description || "",
          admins:
            data.admins || this.selectedTask.admins.map((a) => a.admin) || [],
        });
        this.selectedTask = null;
        this.$notify({
          group: "success",
          text: "Zadanie zostało pomyślnie zaktualizowane",
        });
        document.getElementById("dodAddOrEditTask-close").click();
        await this.$store.dispatch("fetchDodEmployeeTasks", this.employeeId);
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wszystkie pola muszą być uzupełnione",
          });
        } else {
          this.$notify({
            group: "error",
            text: error.data.message,
          });
        }
      }
    },
  },

  computed: {
    tasks() {
      return this.$store.getters.getDodEmployeeTasks;
    },
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
    selectedEmployee() {
      return this.$store.getters.getDodSelectedEmployee;
    },
  },
};
</script>

<style  scoped>
.edit-icon img {
  width: fit-content;
  cursor: pointer;
}
.finish-task-button {
  display: flex;
  width: 192px;
  height: 35px;
  padding: 8.326px 23.721px 8.674px 19.279px;
  align-items: center;
  border-radius: 25px;
  border: 0.5px solid #0ea754;
  background: rgba(9, 7, 65, 0.05);
  color: #0ea754;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  cursor: pointer;
  text-align: center;
}
.task-finished-button {
  text-decoration: underline;
  font-weight: bold;
  font-size: 13px;
  padding: 0;
}
</style>